import React from "react";
import { Icon, Step } from "semantic-ui-react";
import "./styles.css";
const CheckoutSteps = ({ step }) => (
  <Step.Group className="checkout-steps" stackable="tablet">
    <Step
      active={step === 0 ? true : false}
      disabled={step < 0 ? true : false}
      completed={step > 0 ? true : false}
    >
      <Icon name="user" />
      <Step.Content>
        <Step.Title className={step === 0 ? "checkout-steps-title-active" : ""}>
          Información de contacto
        </Step.Title>
        <Step.Description className="checkout-steps-description">
          Ingresa tus datos para poder contactarte
        </Step.Description>
      </Step.Content>
    </Step>
    <Step
      active={step === 1 ? true : false}
      disabled={step < 1 ? true : false}
      completed={step > 1 ? true : false}
    >
      <Icon name="truck" />
      <Step.Content>
        <Step.Title className={step === 1 ? "checkout-steps-title-active" : ""}>
          Envío
        </Step.Title>
        <Step.Description className="checkout-steps-description">
          Ingresa tus datos de envío
        </Step.Description>
      </Step.Content>
    </Step>
    <Step
      active={step === 2 ? true : false}
      disabled={step < 2 ? true : false}
      completed={step > 2 ? true : false}
    >
      <Icon name="payment" />
      <Step.Content>
        <Step.Title className={step === 2 ? "checkout-steps-title-active" : ""}>
          Método de pago
        </Step.Title>
        <Step.Description className="checkout-steps-description">
          Especifica tu método de pago
        </Step.Description>
      </Step.Content>
    </Step>
  </Step.Group>
);

export default CheckoutSteps;
